import {AbstractModel} from './abstract-model';

export class ConstantList extends AbstractModel {
  id: number | null = null;
  identifier: string = '';
  name: string = '';
}
